// extracted by mini-css-extract-plugin
module.exports = {"container":"subscribe_container__Le_T0","wrapper":"subscribe_wrapper__B8aJ_","title":"subscribe_title__T_ZtE"};